import { render, staticRenderFns } from "./BrandDetailEdit.vue?vue&type=template&id=5556b9d4&scoped=true"
import script from "./BrandDetailEdit.vue?vue&type=script&lang=js"
export * from "./BrandDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./BrandDetailEdit.vue?vue&type=style&index=0&id=5556b9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556b9d4",
  null
  
)

export default component.exports